import React from "react";

const HeartIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        d="M7.1001 3L4.1001 5L1.6001 10L4.1001 13.5L9.1001 19L11.6001 21.5L16.1001 17L20.6001 13.5L21.6001 10V6.5L18.6001 3H14.6001L11.6001 5L7.1001 3Z"
        fill="url(#paint0_linear_458_2245)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0932 5.13581C10.0939 2.7984 6.75984 2.16964 4.25479 4.31001C1.74974 6.45038 1.39707 10.029 3.3643 12.5604C4.85019 14.4724 9.07139 18.311 11.0481 20.0749C11.4115 20.3991 11.5932 20.5613 11.8059 20.6251C11.9906 20.6805 12.1959 20.6805 12.3806 20.6251C12.5933 20.5613 12.775 20.3991 13.1384 20.0749C15.1151 18.311 19.3363 14.4724 20.8222 12.5604C22.7894 10.029 22.4798 6.42787 19.9317 4.31001C17.3836 2.19216 14.0926 2.7984 12.0932 5.13581Z"
        stroke="#363636"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_458_2245"
          x1="2.10022"
          y1="6.99979"
          x2="18.6001"
          y2="17"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E63B73" />
          <stop offset="0.194613" stopColor="#E8408F" />
          <stop offset="0.38912" stopColor="#E8BC57" />
          <stop offset="0.59859" stopColor="#85C54B" />
          <stop offset="0.799509" stopColor="#249DD7" />
          <stop offset="1" stopColor="#BF90D7" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default HeartIcon;
